import { deleteRequest, post, put } from 'helpers/api';

export function saveDefaultDeduction(defaultDeduction) {
  const method = defaultDeduction.id ? put : post;
  return method(getPath(defaultDeduction), defaultDeduction);
}

export function deleteDefaultDeduction(defaultDeduction) {
  return deleteRequest(getPath(defaultDeduction));
}

function getPath(defaultDeduction) {
  let path = '/backoffice/default_deductions';

  if (defaultDeduction.id) {
    path += `/${defaultDeduction.id}`;
  }

  return path;
}
